import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'SignInButton' })({
    container: {
        padding: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    compact: {
        background: '#232323 !important',
        color: '#fff',
        width: 48,
        height: 48
    },
    regular: {
        padding: '14px 16px',
        borderRadius: 8,
        background: '#232323 !important',
        color: '#fff',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px',
        boxSizing: 'border-box'
    }
});
